import { IComponentOptions } from 'angular';
import { RegentsPlanningWizardCtrl } from './regents-planning-wizard.controller';

export const RegentsPlanningWizardComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
  },
  controller: RegentsPlanningWizardCtrl,
  template: require('./regents-planning-wizard.html'),
};
